import React from 'react';
import { graphql } from 'gatsby';

export default function ActusPage({ data, pageContext }) {
  return <></>;
}

// querry all vignett for each rea

export const query = graphql`
  query($slug: String) {
    queryPage: allSanityAct(sort: { fields: date, order: DESC }) {
      nodes {
        slug {
          current
        }
        _rawDescription(resolveReferences: { maxDepth: 10 })
        id
        images {
          asset {
            fluid(maxWidth: 100) {
              ...GatsbySanityImageFluid
            }
          }
        }
        name
        date
        vignette {
          asset {
            fluid(maxWidth: 100) {
              ...GatsbySanityImageFluid
            }
          }
        }
      }
    }

    actu: sanityAct(slug: { current: { eq: $slug } }) {
      _rawDescription(resolveReferences: { maxDepth: 10 })
      id
      images {
        asset {
          fluid(maxWidth: 100) {
            ...GatsbySanityImageFluid
          }
        }
      }
      name
      date
    }
  }
`;
